import React from 'react';

import { Divider } from '@mui/material';
import { Button } from '@infoods/lifebase-ui';

import classes from './FreeSuccessResult.module.scss';
import { PaymentResultsInbodyBlock } from '../../../../../inbody';
import { ResultTitle } from '../../../../components/payment-result/ResultTitle/ResultTitle';

type FreeSuccessResultProps = {
  entityId: number | null;
  retryPath: string;
};

const FreeSuccessResult = ({ entityId, retryPath }: FreeSuccessResultProps) => {
  return (
    <div className={classes.container}>
      <ResultTitle
        isSuccessful
        title={
          <>
            <span>You&apos;re All Set!</span>
            <br />
            <span>You Can Now Start Your Scan</span>
          </>
        }
      />
      <Divider />
      {entityId && <PaymentResultsInbodyBlock entityId={entityId} />}
      <Button variant="outlined" href={`#!${retryPath}`}>
        Finish
      </Button>
    </div>
  );
};

export { FreeSuccessResult };
